import { Link, useLocation } from 'react-router-dom'
import { getUserInfo } from '../../../../../utils/reducers/getters'
import { useState, useRef, useCallback } from 'react'
import useOnClickOutside from '../../../../../utils/hooks/useOnClickOut'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ChooseWorkingCenter from '../ChooseWorkingCenter'
import { SignOut } from '../../../LeftMenu/IconMenuBar/UserIcons'
import { AllReduxAppPayloads, GlobalContext } from '../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'

const User: React.FC = () => {
    const user = getUserInfo()
    const { opened, setOpened, ref } = useUserLogic()
    const profileImage = user?.Employee?.profile_image || '/user-png.png'
    return (
        <div className='logo_user cursor-pointer relative' ref={ref}>
            <img src={profileImage} className='rounded-full object-cover h-full w-full header_user_logo' alt='logo user' onClick={() => setOpened((old) => !old)} />
            <div className={'user_menu_main_container absolute z-10 ' + (opened ? 'active' : '')}>
                <UserMenu />
            </div>
        </div>
    )
}

const useUserLogic = () => {
    const ref = useRef<any>(null)
    const [opened, setOpened] = useState(false)
    
    const onReset = useCallback(() => {
        setOpened(false)
    }, [setOpened])
    useOnClickOutside(ref, onReset)

    return { ref, opened, setOpened }
}

const UserMenu: React.FC = () => {
    const { t } = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    const dictUserMenuItems: any = {
        main: t('editProfile', 'Editar perfil'),
        payslip: t('payslips', 'Nóminas'),
        expenses: t('expenses', 'Gastos'),
        quickAccess: t('quickAcces', 'Acceso rápido'),
        parameters: t('parameters', 'Parámetros'),
        task: t('taskHelper', 'Ayudante de tareas'),
    }

    for (const element in dictUserMenuItems) {
        const item = dictUserMenuItems[element];
        renderThis.push(
            <UserLink route={element} text={item} key={element} />
        )
    }

    return (
        <div className='flex flex-col bg-white p-20 rounded-8 shadow-lg gap-y-15 mr-15 user_menu_main' >
            <UserMainConnector />
            <div className='px-6'>
                <div className='border-b border-gray-EE' />
            </div>
            <div className='flex flex-col gap-y-2'>
                {renderThis}
            </div>
            <div className='px-6'>
                <div className='border-b border-gray-EE' />
            </div>
            <SignOut text={t('signOut', 'Cerrar sesión')} />
        </div>
    )
}

interface UserLinkProps {
    text: string
    route: string
}

const UserLink: React.FC<UserLinkProps> = ({ route, text }) => {
    const { pathname } = useLocation()
    const finalRoute = '/employeeProfile/' + route
    const activeClassName = pathname === finalRoute ? 'bg-green-DB medium14' : ''
    return (
        <Link to={finalRoute}>
            <div className={'hover:bg-green-DB px-6 py-3 rounded-sm cursor-pointer ' + activeClassName}>{text}</div>
        </Link>
    )
}

interface UserMainProps extends ReduxUserMainConnector {}

const UserMain: React.FC<UserMainProps> = ({ workingCenters, WorkingCenterId }) => {
    const { t } = useTwinTranslation()
    const user = getUserInfo()
    const profileImage = user?.Employee?.profile_image || '/user-png.png'
    const haveWorkingCenterStations = WorkingCenterId && workingCenters?.[WorkingCenterId]?.WorkingCenterStations?.length
    if (haveWorkingCenterStations) {
        return <UserMainWithWorkingCenterStations profileImage={profileImage} employeeName={user?.Employee?.fullname_short || ''} />
    }
    return (
        <div className='flex flex-row flex-auto gap-x-15'>
            <div className='h-50 w-50'>
                <img src={profileImage} className='rounded-full object-cover h-full w-full' alt='logo user' />
            </div>
            <div className='flex flex-col flex-auto w-1 gap-y-15'>
                <div className='medium16 twin_ellipsis'>{user?.Employee?.fullname_short}</div>
                <ChooseWorkingCenter label={t('workingCenter', 'Centro de trabajo')} />
            </div>
        </div>
    )
}

interface UserMainWithWorkingCenterStationsProps {
    profileImage: string
    employeeName: string
}

const UserMainWithWorkingCenterStations: React.FC<UserMainWithWorkingCenterStationsProps> = ({ profileImage, employeeName }) => {
    const { t } = useTwinTranslation()
    return (
        <div>
            <div className='flex flex-row flex-auto gap-x-15'>
                <div className='h-50 w-50'>
                    <img src={profileImage} className='rounded-full object-cover h-full w-full' alt='logo user' />
                </div>
                <div className='flex flex-col flex-auto w-1 gap-y-27'>
                    <div className='medium16 twin_ellipsis'>{employeeName}</div>
                </div>
            </div>
            <div className='mt-30'>
                <ChooseWorkingCenter label={t('workingCenter', 'Centro de trabajo')} secondLabel={t('workStation', 'Puesto')} />
            </div>
        </div>
    )
}


const mapUserMainConnector = (state: AllReduxAppPayloads) => ({ workingCenters: state.user?.extraData.WorkingCenters, WorkingCenterId: state.user?.extraData.WorkingCenterId, WorkingCenterStationId: state.user?.extraData.WorkingCenterStationId })
export const userMainConnector = connect(mapUserMainConnector, null, null, { context: GlobalContext })
export type ReduxUserMainConnector = ConnectedProps<typeof userMainConnector>

const UserMainConnector = userMainConnector(UserMain)

export default User